import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa';
import { variants, th } from 'style/theme';
import TextInput from '../TextInput';

const Icon = styled.div`
  ${variants('variant', {
    light: css`
      color: ${th('colors.white')};
    `,
    dark: css`
      color: ${th('colors.black')};
    `
  })};

  cursor: pointer;
  position: absolute;
  right: 5px;
  bottom: 0;
  width: 18px;

  > * {
    width: 100%;
  }
`;

const PasswordInput = ({
  variant,
  placeholder,
  formik,
  name,
  validateWhileTyping,
  ...props
}) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <TextInput
      variant={variant}
      placeholder={placeholder}
      type={isVisible ? 'text' : 'password'}
      formik={formik}
      name={name}
      validateWhileTyping={validateWhileTyping}
      {...props}
    >
      <Icon variant={variant} onClick={() => setIsVisible(!isVisible)}>
        {isVisible ? <FaRegEyeSlash /> : <FaRegEye />}
      </Icon>
    </TextInput>
  );
};

PasswordInput.propTypes = {
  formik: PropTypes.object,
  name: PropTypes.string.isRequired,
  variant: PropTypes.string,
  validateWhileTyping: PropTypes.bool,
  placeholder: PropTypes.string
};

PasswordInput.defaultProps = {
  variant: 'dark',
  placeholder: '•••••••••••••'
};

export default PasswordInput;
